<div class="canvas-container mt-4 d-flex flex-column">
<div class="custom-row" *ngFor="let user of userList">
  <div class="d-flex gap-3 align-items-center" [routerLink]="['/contact/' + user.id]" [state]="user">
    <app-user-photo [user]="user" textColor="#002060"></app-user-photo>
    <div class="roboto-font align-self-center dark-blue">{{ user.firstname }} {{ user.lastname }}</div>
    <div class="ms-auto"><i class="demo-icon icon-icons8-forward dark-blue"></i></div>
  </div>
</div>
</div>
